import hotkeys from 'hotkeys-js';

// default scope is "all" which means that regardless of the current scope, the shortcut is active
export type ShortcutScope =
    /** Apply the shortcut at all times */
    | 'all'
    /** Apply the shortcut when no editor is focused (application itself is focused) */
    | 'application'
    /** Apply the shortcut when typing in a basic editor */
    | 'basic-editor'
    /** Apply the shortcut when typing in a expression editor */
    | 'expression-editor'
    /** Apply the shortcut when the editor is focused but the selection is collapsed */
    | 'editor-selection-collapsed'
    /** Apply the shortcut when the editor is focused but the selection is expanded */
    | 'editor-selection-expanded'
    /** Apply the shortcut when the user is editing a modal for a block */
    | 'editor-block-modal';

// we start in the "application" scope
hotkeys.setScope('application');

/**
 * Set the current scope to match keyboard shortcuts.
 * Returns a function to return to the previous scope.
 */
export function setKeyboardShortcutsScope(scope: ShortcutScope): () => void {
    const previousScope = hotkeys.getScope();
    hotkeys.setScope(scope);

    return () => {
        hotkeys.setScope(previousScope);
    };
}
